import { CreditUse, ActivityType } from '@/gql/graphql';
import {
	HouseType,
	OldestDuePayment,
	OperatingTimeRanges,
	TransportationMethod
} from '@/graphql/__generated__/van-credits';
import {
	HouseTypeMap,
	TransportationMethodMap,
	CreditUseMap,
	BusinessActivityMap,
	OperatingTimeRangeMap,
	OldestDuePaymentMap
} from '@/utils/maps';
import { formatMoney } from '@/utils/utils';

export const formatValue = (value: any, t: any, key?: string): string => {
	if (value === null || value === undefined) return '';
	if (key === 'houseType') return t(HouseTypeMap[value as HouseType]) || value;
	if (key === 'transportationMethod')
		return t(TransportationMethodMap[value as TransportationMethod]) || value;
	if (key === 'creditUse')
		return CreditUseMap[value as CreditUse] ? t(CreditUseMap[value as CreditUse]) : value;
	if (key === 'activityType')
		return BusinessActivityMap[value as ActivityType]
			? t(BusinessActivityMap[value as ActivityType])
			: value;
	if (key === 'operatingTimeRange')
		return t(OperatingTimeRangeMap[value as OperatingTimeRanges]) || value;
	if (typeof value === 'string' && value.includes('MXN')) {
		return formatMoney(value);
	}
	if (key === 'oldestDuePayment') return t(OldestDuePaymentMap[value as OldestDuePayment]) || value;
	if (key === 'downPaymentPercentage' && value !== null && value !== undefined) {
		return `${value}%`;
	}
	if (typeof value === 'boolean') return value ? t('Yes') : t('No');
	if (value instanceof Date) return value.toLocaleDateString();
	return String(value);
};

export const getSelectOptions = (key: string, t: any) => {
	const emptyOption = { value: '', label: t('SelectOption') };

	if (key === 'houseType') {
		return [
			emptyOption,
			...Object.keys(HouseTypeMap).map((key) => ({
				value: key,
				label: t(HouseTypeMap[key as HouseType])
			}))
		];
	}
	if (key === 'transportationMethod') {
		return [
			emptyOption,
			...Object.keys(TransportationMethodMap).map((key) => ({
				value: key,
				label: t(TransportationMethodMap[key as TransportationMethod])
			}))
		];
	}
	if (key === 'creditUse') {
		return [
			emptyOption,
			...Object.keys(CreditUseMap).map((key) => ({
				value: key,
				label: t(CreditUseMap[key as CreditUse])
			}))
		];
	}
	if (key === 'activityType') {
		return [
			emptyOption,
			...Object.keys(BusinessActivityMap).map((key) => ({
				value: key,
				label: t(BusinessActivityMap[key as ActivityType])
			}))
		];
	}
	if (key === 'operatingTimeRange') {
		return [
			emptyOption,
			...Object.keys(OperatingTimeRangeMap).map((key) => ({
				value: key,
				label: t(OperatingTimeRangeMap[key as OperatingTimeRanges])
			}))
		];
	}
	return [];
};

export const moneyToString = (amount: number | null, currency: string): string => {
	if (amount === null || amount === 0) return '0.00 MXN';
	return `${amount.toFixed(2)} ${currency}`;
};
